




































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter, Mutation } from "vuex-class";
import {
  SettingsGetters,
  SettingsMutations,
  SettingsTitle,
  UpdateUserErrorProps
} from "@/components/settings/types";
import { Namespace } from "@/store/types";
import {
  ChildUpdate,
  NewUser,
  UserInfo,
  UserRole,
  UserUpdate
} from "@/services/apiService/api.types";
import SpatialNavigation from "spatial-navigation-js";
import { keyCodeFinder } from "@/services/keyCodeService/keyCodeService";
import { KeySet } from "@/services/keyCodeService/keyCode.types";
import SettingsConfirmOverlay from "@/components/settings/components/SettingsConfirmOverlay.vue";
import { RouteName } from "@/router/types";
import apiService from "@/services/apiService/apiService";
import {
  LocaleSettingsConfirmModal,
  LocaleSettingsPageTitles,
  LocaleSettingsPinModal
} from "@/plugins/i18n/types";
import { i18n } from "@/plugins/i18n/vue-i18n-plugin";
import { defaultUserInfo } from "@/helpers/constants";
import apiStorageInterface from "@/services/apiStorageInterface";

@Component({
  components: {
    SettingsConfirmOverlay
  }
})
export default class UserEditForm extends Vue {
  @Mutation(SettingsMutations.setSettingsPageTitle, {
    namespace: Namespace.Settings
  })
  setSettingsPageTitle!: (settingsPageTitle?: SettingsTitle) => void;

  @Mutation(SettingsMutations.setConfirmModalStatus, {
    namespace: Namespace.Settings
  })
  setConfirmModalStatus!: (status: boolean) => void;

  @Mutation(SettingsMutations.setOpenConfirmModal, {
    namespace: Namespace.Settings
  })
  setOpenConfirmModal!: (status: boolean) => void;

  @Mutation(SettingsMutations.setConfirmModalMsg, {
    namespace: Namespace.Settings
  })
  setConfirmModalMsg!: (message: string) => void;

  @Mutation(SettingsMutations.setUserToEdit, {
    namespace: Namespace.Settings
  })
  setUserToEdit!: (userData?: UserInfo) => void;

  @Getter(SettingsGetters.getConfirmModalStatus, {
    namespace: Namespace.Settings
  })
  getConfirmModalStatus!: boolean;

  @Getter(SettingsGetters.getEncodedPin, {
    namespace: Namespace.Settings
  })
  getEncodedPin!: string;

  @Getter(SettingsGetters.getUserToEdit, { namespace: Namespace.Settings })
  getUserToEdit!: UserInfo;

  @Getter(SettingsGetters.getOpenConfirmModal, {
    namespace: Namespace.Settings
  })
  getOpenConfirmModal!: boolean;

  circleHeight = 0;

  updateData: UserUpdate = {
    username: "",
    last_name: "",
    mobile_number: "",
    first_name: "",
    email: "",
    password: "",
    old_password: "",
    password_confirm: ""
  };

  updateErrors: Record<UpdateUserErrorProps, string> = {
    [UpdateUserErrorProps.username]: "",
    [UpdateUserErrorProps.first_name]: "",
    [UpdateUserErrorProps.last_name]: "",
    [UpdateUserErrorProps.password_confirm]: "",
    [UpdateUserErrorProps.password]: "",
    [UpdateUserErrorProps.old_password]: "",
    [UpdateUserErrorProps.old_pin_code]: "",
    [UpdateUserErrorProps.pin_code]: "",
    [UpdateUserErrorProps.confirm_pin_code]: ""
  };

  userRole = UserRole;

  LocaleSettingsPinModal = LocaleSettingsPinModal;

  userInfo: UserInfo = defaultUserInfo;

  get userInitials(): string {
    if (this.getUserToEdit) {
      return this.getUserToEdit.profile.first_name
        .charAt(0)
        .concat(this.getUserToEdit.profile.last_name.charAt(0))
        .toUpperCase();
    }

    return "**";
  }

  get editIcon(): string {
    return require("@/assets/svg/svg-settings/13-edit-input.svg");
  }

  //@TODO: refactor this shit(damn deadline)
  created(): void {
    this.setSettingsPageTitle({
      heading: i18n.t(LocaleSettingsPageTitles.settingsEditUserTitle) as string,
      subHeading: i18n.t(
        LocaleSettingsPageTitles.settingsEditUserSubTitle
      ) as string
    });
    if (this.getUserToEdit) {
      this.updateData.username = this.getUserToEdit.username;
      this.updateData.email = this.getUserToEdit.email;
      this.updateData.first_name = this.getUserToEdit.profile.first_name;
      this.updateData.last_name = this.getUserToEdit.profile.last_name;
      this.updateData.mobile_number = this.getUserToEdit.profile.mobile_number
        ? this.getUserToEdit.profile.mobile_number
        : "";
    }
  }

  async mounted(): Promise<void> {
    window.addEventListener("resize", () => {
      this.checkCircleWidth();
    });
    //initial value
    this.checkCircleWidth();
    SpatialNavigation.focus("#username");

    this.userInfo = await apiStorageInterface.fetchUserInfo();
  }

  checkCircleWidth(): void {
    const elem = document.getElementById("initials");
    if (elem) {
      this.circleHeight = elem.clientWidth;
    }
  }

  handleReturn(event: KeyboardEvent): void {
    const openOverlay = this.checkIfInputIsEmpty();
    switch (keyCodeFinder(event.keyCode)) {
      case KeySet.KEY_BACK:
        if (openOverlay) {
          this.setOpenConfirmModal(true);
          this.setConfirmModalMsg(
            i18n.t(LocaleSettingsConfirmModal.backToSettings) as string
          );
        }
        break;
    }
  }

  checkIfInputIsEmpty(): boolean {
    const activeElement = document.activeElement;
    if (!activeElement) {
      return false;
    }

    if (activeElement.nodeName !== "INPUT") {
      return false;
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    return activeElement.value === "";
  }

  async handleActions(): Promise<void> {
    if (this.getUserToEdit) {
      await this.editUser();
      return;
    }

    await this.createChildUser();
  }

  async editUser(): Promise<void> {
    this.updateErrors = {
      [UpdateUserErrorProps.username]: "",
      [UpdateUserErrorProps.first_name]: "",
      [UpdateUserErrorProps.last_name]: "",
      [UpdateUserErrorProps.password_confirm]: "",
      [UpdateUserErrorProps.password]: "",
      [UpdateUserErrorProps.old_password]: "",
      [UpdateUserErrorProps.old_pin_code]: "",
      [UpdateUserErrorProps.pin_code]: "",
      [UpdateUserErrorProps.confirm_pin_code]: ""
    };
    try {
      if (this.userInfo.id !== this.getUserToEdit.id) {
        let childData: ChildUpdate = Object.assign<UserUpdate, ChildUpdate>(
          this.updateData,
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-ignore
          childData
        );
        childData = Object.assign<{ id: number }, ChildUpdate>(
          { id: this.getUserToEdit.id },
          childData
        );

        await apiService.updateChildUser(childData, this.getEncodedPin);
        await apiStorageInterface.fetchUserInfo();
        this.$router.back();
      }
      await apiService.updateCurrentUser(this.updateData, this.getEncodedPin);
      await apiStorageInterface.fetchUserInfo();
      this.$router.back();
    } catch (e) {
      if (Array.isArray(e.response.data)) {
        e.response.data.forEach(
          (res: { field: UpdateUserErrorProps; message: string }) => {
            this.updateErrors[res.field] = res.message;
          }
        );
      }
    }
  }

  async createChildUser(): Promise<void> {
    this.updateErrors = {
      [UpdateUserErrorProps.username]: "",
      [UpdateUserErrorProps.first_name]: "",
      [UpdateUserErrorProps.last_name]: "",
      [UpdateUserErrorProps.password_confirm]: "",
      [UpdateUserErrorProps.password]: "",
      [UpdateUserErrorProps.old_password]: "",
      [UpdateUserErrorProps.old_pin_code]: "",
      [UpdateUserErrorProps.pin_code]: "",
      [UpdateUserErrorProps.confirm_pin_code]: ""
    };
    let newChild: NewUser = {
      username: this.updateData.username,
      first_name: this.updateData.first_name,
      last_name: this.updateData.last_name,
      email: this.updateData.email,
      role: UserRole.Child,
      password: this.updateData.password,
      password_confirm: this.updateData.password_confirm,
      pin_code: this.updateData.pin_code,
      confirm_pin_code: this.updateData.confirm_pin_code
    };
    try {
      await apiService.createChildUser(newChild, this.getEncodedPin);
      this.$router.back();
    } catch (e) {
      if (Array.isArray(e.response.data)) {
        e.response.data.forEach(
          (res: { field: UpdateUserErrorProps; message: string }) => {
            this.updateErrors[res.field] = res.message;
          }
        );
      }
    }
  }

  @Watch("getOpenConfirmModal")
  handleConfirmOverlayClose(newVal: boolean): void {
    if (!newVal) {
      if (!this.getConfirmModalStatus) {
        SpatialNavigation.focus("#username");

        return;
      }

      this.setConfirmModalStatus(false);
      this.$router.push({ name: RouteName.Settings });
    }
  }

  beforeDestroy(): void {
    window.removeEventListener("resize", this.checkCircleWidth);
    this.setUserToEdit();
  }
}
